const { compactFields } = require('hooks/useFormPrimitives/formModelUtils');

const FormConfig = module.exports = function formConfig(props = {}) {

    const {
        formId,
        groupDetails,
        onSubmit
    } = props;

    return {
        title: internals.buildTitle(props),
        defaults: groupDetails,
        fields: FormConfig.buildFields(props),
        formId,
        onSubmit
    };
};

FormConfig.buildFormConfig = FormConfig;

FormConfig.buildFields = function buildFields(props = {}) {

    return internals.buildFields(props);
};

FormConfig.buildSubmitPayload = function buildSubmitPayload(data = {}) {

    return data;
};

const internals = {};

internals.when = (condition, value) => {

    if (!condition) {
        return null;
    }

    return typeof value === 'function' ? value() : value;
};

internals.buildTitle = ({
    groupDetails,
    isCreate,
    schoolName
}) => {

    return isCreate
        ? `Create a group for ${schoolName}`
        : `Edit ${groupDetails?.name?.replace(/ Group$/i, '')} Group`;
};

internals.buildRoleOptions = (schoolRoles = []) => schoolRoles.map(({ id, label }) => ({
    value: id,
    label
}));

internals.buildChatSettingsFields = ({
    isAnnouncement,
    schoolEnableGroupGifs,
    schoolEnableReactions
}) => {

    const shouldShowChatSettings = (schoolEnableReactions && !isAnnouncement) || schoolEnableGroupGifs;

    return compactFields(internals.when(shouldShowChatSettings, [
        {
            type: 'title',
            text: 'Chat Settings'
        },
        {
            type: 'explainer',
            text: 'Control the chat features available to this group'
        },
        {
            type: 'group',
            fields: compactFields(
                schoolEnableReactions && !isAnnouncement && {
                    type: 'CheckboxField',
                    name: 'enableReactions',
                    label: 'Enable Reactions',
                    default: true
                },
                schoolEnableGroupGifs && {
                    type: 'CheckboxField',
                    name: 'enableGifPicker',
                    label: 'Enable Gif Picker'
                }
            )
        }
    ]));
};

internals.buildFields = (props = {}) => {

    const {
        isAnnouncement,
        isCompany,
        isCommunity,
        isCreate,
        isSchoolOnline,
        isTeamsApp,
        onAnnouncementChange,
        schoolEnableGroupGifs,
        schoolEnableReactions,
        schoolRoles
    } = props;

    return compactFields(
        {
            type: 'EmojiField',
            name: 'emojiSymbol',
            label: 'Group Emoji'
        },
        isCreate && {
            type: 'break'
        },
        isCreate && {
            type: 'CheckboxField',
            name: 'isAnnouncement',
            label: 'Is Announcements Only Group',
            fullWidth: true,
            onChange: onAnnouncementChange
        },
        {
            type: 'explainer',
            text: 'Who should have permissions for this group?'
        },
        {
            type: 'MultiSelectField',
            name: 'roles',
            label: 'Roles',
            options: internals.buildRoleOptions(schoolRoles),
            required: true
        },
        {
            type: 'title',
            text: 'Details'
        },
        {
            type: 'TextField',
            name: 'name',
            label: 'Group Name',
            required: true
        },
        {
            type: 'TextField',
            name: 'facilitator',
            label: 'Facilitator'
        },
        !isTeamsApp && !isCompany && !isCommunity && !isSchoolOnline && {
            type: 'TextField',
            name: 'campus',
            label: 'Campus'
        },
        {
            type: 'TextField',
            name: 'shortDescription',
            label: 'Short Description'
        },
        {
            type: 'TextField',
            name: 'semester',
            label: 'Term or Semester'
        },
        {
            type: 'TextField',
            name: 'additionalDescription',
            label: 'Additional Description'
        },
        {
            type: 'TextField',
            name: 'classLocation',
            label: 'Location'
        },
        {
            type: 'TextField',
            name: 'misc',
            label: 'Other Search Terms'
        },
        {
            type: 'title',
            text: 'Privacy Settings'
        },
        {
            type: 'explainer',
            text: 'A private group is not visible in search and members must be manually added'
        },
        {
            type: 'CheckboxField',
            name: 'private',
            label: 'Set As Private'
        },
        internals.buildChatSettingsFields({
            isAnnouncement,
            schoolEnableGroupGifs,
            schoolEnableReactions
        })
    );
};

FormConfig.internals = internals;
